module.exports = __webpack_public_path__ + "img/menu.c60445de.svg";